// Generated by scripts/write-version.js — do not edit.
export const release = "2026.3.1";
export const buildStamp = "20261006143530";
const buildStampDefault = "20261006143530";
export default buildStampDefault;
